import { Splide } from '@splidejs/splide';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
	const sections = document.querySelectorAll('.products-grid');

	sections.forEach((section) => {
		const slider = section.querySelector('.splide');

		if (slider) {
			const splide = new Splide(slider, {
				gap: 12,
				speed: 500,
				arrows: false,
				pagination: false,
				type: 'loop',
				autoWidth: true,
				mediaQuery: 'min',
				drag: 'free',
				breakpoints: {
					744: {
						gap: 20
					},
					1024: {
						destroy: true,
					},
				}
			}).mount();
		}


		const centerClass = 'has-reached-center';
		ScrollTrigger.create({
			trigger: section,
			start: 'center 10%',
			end: 'bottom top',
			onEnter: () => section.classList.add(centerClass),
			onEnterBack: () => section.classList.add(centerClass),
			onLeave: () => section.classList.remove(centerClass),
			onLeaveBack: () => section.classList.remove(centerClass)
		});
	});
}